import { createBrowserHistory } from "history";

export const browserHistory = createBrowserHistory();
((window as any)["browserHistory"] as any) = browserHistory;
